module.exports = __webpack_public_path__ + "img/home-db.21ca9c76.png";